module.exports = __webpack_public_path__ + "img/6.Ιθάκη-min.6b3fff5f.jpg";